import React from "react";
import Skeleton from "@/app/_partials/_skeleton/Skeleton";

export default function TestimonialSkeleton() {
  // return <Skeleton height={1135} />;

  return (
    <>
      <Skeleton height={230} borderRadius={20} className="mt-5" />

      <Skeleton height={1000} borderRadius={20} className="mt-3" />
    </>
  );
}
